
export default class tdHotJar {



    static isAttached = false;


    /**
     *
     * @param language
     */
    static attach(language = 'ro_RO') {


        if (tdHotJar.isAttached === true) {
            console.log('%cERROR', 'background: #ffaa00; color: #ffffff; padding:3px 6px', 'hotJar already attached!');
            return;
        }


        // if (language !== 'en_US') {
        //     return;
        // }



        //alert("Attached");
        console.log("HJ - attached");

            (function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:2301910,hjsv:6};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');

    }





}



// WEBPACK FOOTER //
// ./src/tdHotJar.js